export function getEnv() {
  const host = window.location.href;

  let regex = /^http[s]?:\/\/portal-(uat5)\.smiles.*/i;
  if (host.match(regex)) {
    return 'uat5';
  }

  regex = /^http[s]?:\/\/portal-(dev3)\.smiles.*/i;
  if (host.match(regex)) {
    return 'dev3';
  }

  regex = /^http[s]?:\/\/portal-(dev2)\.smiles.*/i;
  if (host.match(regex)) {
    return 'dev2';
  }

  regex = /^http[s]?:\/\/portal-(dev1)\.smiles.*/i;
  if (host.match(regex)) {
    return 'dev1';
  }

  regex = /^http[s]?:\/\/localhost*/i;
  if (host.match(regex)) {
    return 'dev2';
  }

  return 'prd';
}
